import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

var Footer = function Footer(_ref) {
  var children = _ref.children;
  return React.createElement(
    'div',
    { className: styles.footer, 'data-hook': 'menu-footer' },
    children
  );
};

Footer.propTypes = {
  children: PropTypes.node
};

export default Footer;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/SideMenu/core/footer/index.js